export default {"src":"/_next/static/media/lock_24.1cf42e8b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};